<template>
  <div id="app">
    <div v-if="disdh" class="animation">
      <img src="./assets/img/leftnav/logo.png" alt="" />
      <div>布尔清单</div>
      <p>版本：1.2.0</p>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      disdh: false
    }
  },
  created() {
    if (sessionStorage.getItem('dh') == null) {
      this.disdh = true
      setTimeout(() => {
        this.disdh = false
        sessionStorage.setItem('dh', this.disdh)
      }, 2000)
    }
  },
  mounted() {
    // setTimeout(() => {
    //   let root = document.querySelector(':root')
    //   console.error(root)
    //   root.style.setProperty('--color-theme', '#f00')
    // }, 2000)
  }
}
</script>
<style lang="scss">
@import './assets/css/base.css';
.animation {
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  img {
    width: 300px;
    height: 300px;
  }
  div {
    margin: 80px 0 50px 0;
    font-size: 30px;
  }
}
</style>